import React, { useState } from "react";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../gComponents/gButton";

export default function CreateWallet(props) {
  const [openSnackbar] = useSnackbar();
  const [isDisabled, setIsDisabled] = useState(false);
  const initialValues = {
    customer_id: props.id,
    amount: "",
    wallet_type: "",
    description: "",
  };

  const WalletType = [
    {
      title: "Debit",
      value: "debit",
    },
    {
      title: "Credit",
      value: "credit",
    },
  ];

  const onSubmit = (values) => {
    setIsDisabled(true);
    console.log(values);
    ApiService({
      method: "POST",
      route: "customer/wallet",
      body: values,
    }).then((response) => {
      console.log("r" + response.data.status_code);
      if (response.data.status_code === 1) {
        props.setWalletvisible(false);
        props.onSubmit();
      }
      setIsDisabled(false);
      openSnackbar(response.data.message);
      return;
    });
  };

  const validationSchema = Yup.object({
    amount: Yup.string().required("Required"),
    wallet_type: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
  });

  if (props.walletvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header"> Adjust Wallet </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ setFieldValue }) => (
            <Form>
              <FormikControl
                control="input"
                type="text"
                label="Amount"
                name="amount"
                onChange={(event) => {
                  const re = /^[0-9.\b]+$/;
                  if (event.target.value && !re.test(event.target.value)) {
                    return;
                  } else {
                    setFieldValue("amount", event.target.value);
                  }
                }}
              />

              <FormikControl
                control="select"
                as="select"
                label="Wallet Type"
                name="wallet_type"
                options={WalletType}
                key_title="title"
                key_value="value"
              />
              <FormikControl
                control="input"
                type="text"
                as="textarea"
                label="Description"
                name="description"
              />

              <br />

              <GButton
                type="submit"
                disabled={isDisabled}
                variant="condensed"
                children="Add"
                style={{ width: "calc(100% - 30px)", margin: "0 15px" }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
